import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

// Sub-paths, not the barrels: those drag the legacy coreOld graph into every grid test.
import { CopyValueButton } from 'core/elements/CopyValueButton';
import TextLine from 'core/elements/TextLine';
import { ITradeAgreement } from 'quotes/types';
import { Direction } from 'theme/enums';

// The dash of an empty value has nothing to copy.
export const SpaCostRegistrationNumCell = ({
  data,
  valueFormatted,
}: ICellRendererParams<ITradeAgreement>) => {
  const { t } = useTranslation();

  if (!data?.spaCostRegistrationNum) {
    return <>{valueFormatted}</>;
  }

  return (
    <Stack direction={Direction.ROW} sx={{ alignItems: 'center', gap: 0.5, minWidth: 0 }}>
      <TextLine text={valueFormatted} textEllipsis sx={{ minWidth: 0 }} />

      <CopyValueButton
        value={data.spaCostRegistrationNum}
        label={t('tooltipCopySpaCostRegistrationNum')}
      />
    </Stack>
  );
};
